export function recipientIds(values, ownId) {
  return [...new Set(values.map(Number).filter((id) => Number.isSafeInteger(id) && id > 0 && id !== Number(ownId)))];
}
export function normalizeRecipients(users, ownId) {
  if (!Array.isArray(users)) throw new Error('Invalid recipients response');
  const ids = new Set(recipientIds(users.map((user) => user?.user_id), ownId));
  return users.flatMap((user) => {
    const id = Number(user?.user_id);
    if (!ids.delete(id)) return [];
    return [{ ...user, user_id: id }];
  });
}
